import(/* webpackMode: "eager" */ "/workspace/src/app/products/page.tsx");
